export const trimTitleToSlug = (title: string) => {
  return title
    .trim()
    .toLowerCase()
    .replace(/\s/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/[^a-z0-9-]/gi, '');
};
